import store from '@/store'

export default {
  onEdit (to, from, next) {
    let promises = []
    promises.push(store.dispatch('branchTypes/query'))
    promises.push(store.dispatch('layouts/get', to.params))
    Promise.all(promises)
      .then(next)
      .catch(next)
  },
  onCreate (to, from, next) {
    let promises = []
    promises.push(store.dispatch('divisions/query'))
    promises.push(store.dispatch('branchTypes/query'))
    Promise.all(promises)
      .then(next)
      .catch(next)
  }
}



// WEBPACK FOOTER //
// ./src/guards/layouts.guards.js